module.exports = __webpack_public_path__ + "assets/img/sy_jckc_byx.9636c67f.png";